import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';
import { MyBidsOffersResponse } from '../components/bids-and-offers/lots.model';

@Injectable({
  providedIn: 'root',
})
export class MyBidsOffersService extends Query<MyBidsOffersResponse> {
  document = gql`
    query UserLotsQuery($userID: String!) {
      lots(user_id: $userID) {
        _id
        createdAt
        lot_type
        indication
        origin
        commodity
        product_type
        grade
        status
        specifications {
          title
          value
        }
        price {
          __typename
          ... on CashPrice {
            amount
          }

          __typename
          ... on BasisPrice {
            month
            year
            basisPoints
            product_code
          }
        }
        currency
        volume_value
        units
        ship_begin
        ship_end
        destination
        delivery_type
        container_type
        rules_to_govern
        delivery_option
        time_frame
        user_id
      }

      negotiations {
        _id
        user_id
        lot_user_id
        lot_id
        status
      }
    }
  `;
}
